import * as classNames from 'classnames'
import * as React from 'react'
import { DAYS_OF_WEEK } from '../../../state/constants/index'
import { IWorkingHoursItem } from '../../../types/index'
import { capitalToUpperCase } from '../../../utils/index'

interface IServiceViewWorkingHoursProps {
  workingHoursList: { [key: number]: IWorkingHoursItem }
}

const ServiceViewWorkingHours = (props: IServiceViewWorkingHoursProps) => {
  return (
    <React.Fragment>
      {Object.values(props.workingHoursList).map(it => (
        <ServiceViewWorkingHoursItem key={`item-${it.id}`} item={it} />
      ))}
    </React.Fragment>
  )
}

const ServiceViewWorkingHoursItem = ({ item }: { item: IWorkingHoursItem }) => (
  <div className='mt3'>
    <div className='flex flex-row'>
      <div className='col-2 h5 font-dark-grey'>From</div>
      <div className='col-2 ml2 h5 font-dark-grey'>Until</div>
      <div className='pl2 h5 font-dark-grey'>On these days</div>
    </div>
    <div className='flex flex-row items-center mt02'>
      <div className='col-2'>{item.from}</div>
      <div className='col-2 ml2'>{item.until}</div>
      <div className='pl2'>
        <ViewDaysOfWeek days={item.days} id={item.id} />
      </div>
    </div>
  </div>
)

const ViewDaysOfWeek = ({ days, id }: { days: DAYS_OF_WEEK[]; id: string }) => {
  const daysOfWeek = [
    DAYS_OF_WEEK.SUNDAY,
    DAYS_OF_WEEK.MONDAY,
    DAYS_OF_WEEK.TUESDAY,
    DAYS_OF_WEEK.WEDNESDAY,
    DAYS_OF_WEEK.THURSDAY,
    DAYS_OF_WEEK.FRIDAY,
    DAYS_OF_WEEK.SATARDAY
  ]

  return (
    <div className='flex'>
      {daysOfWeek.map(it => {
        const classes = classNames('day-of-week p1', {
          'bg-light-grey2 font-grey2': !days.includes(it),
          'bg-green font-white': days.includes(it)
        })

        return (
          <div className={classes} key={`${it}-${id}`}>
            {capitalToUpperCase(it as string)}
          </div>
        )
      })}
    </div>
  )
}

export default ServiceViewWorkingHours



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewWorkingHours.tsx